/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});


var allCheckboxes = document.querySelectorAll('input[type=checkbox]');
var allProducts = Array.from(document.querySelectorAll('.product'));
var checked = {};

getChecked('merkki');
getChecked('malli');
getChecked('tyyppi');

Array.prototype.forEach.call(allCheckboxes, function (el) {
  el.addEventListener('change', function (e) {
    toggleCheckbox(e);
    updateSelectedFilters();
  });
});

function toggleCheckbox(e) {
  getChecked(e.target.name);
  setVisibility();
}

function getChecked(name) {
  checked[name] = Array.from(document.querySelectorAll('input[name=' + name + ']:checked')).map(function (el) {
    return el.value;
  });
}

function setVisibility() {
  allProducts.forEach(function (el) {
    var merkki = checked.merkki.length ? intersection(Array.from(el.classList), checked.merkki).length : true;
    var malli = checked.malli.length ? intersection(Array.from(el.classList), checked.malli).length : true;
    var tyyppi = checked.tyyppi.length ? intersection(Array.from(el.classList), checked.tyyppi).length : true;
    if (merkki && malli && tyyppi) {
      el.style.display = 'block';
    } else {
      el.style.display = 'none';
    }
  });
}

function intersection(arr1, arr2) {
  return arr1.filter(value => arr2.includes(value));
}

function updateSelectedFilters() {
  var selectedFiltersDiv = document.getElementById('selected-filters');
  selectedFiltersDiv.innerHTML = ''; // Clear previous content

  Object.keys(checked).forEach(function (key) {
    checked[key].forEach(function (value) {
      var filterDiv = document.createElement('div');
      
      // Add a class name to the created div
      filterDiv.classList.add('selected-filter');
      
      filterDiv.textContent = key + ': ' + value;
      filterDiv.addEventListener('click', function () {
        // Remove the clicked value from the checked object
        checked[key] = checked[key].filter(function (v) {
          return v !== value;
        });
        // Update visibility based on the modified checked object
        setVisibility();
        // Update the displayed filters
        updateSelectedFilters();
        // Uncheck the corresponding checkbox
        document.querySelector('input[name=' + key + '][value="' + value + '"]').checked = false;
      });
      selectedFiltersDiv.appendChild(filterDiv);
    });
  });
}

